import { Fragment, Suspense, useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import { useCheckoutSessionConfig } from "@dues/hooks/useCheckoutSessionConfig";
import { useRedline } from "@libs/redline";
import useDatadog from "@libs/utils/hooks/datadog/useDatadog";

import {
	PrivateRouter as AdmissionPrivateRouter,
	PublicRouter as AdmissionPublicRouter,
} from "@admission/routes/Router";
import { BureauPrivateRouter } from "@bureau/routes/Router";
import { DuesPrivateRouter } from "@dues/routes/Router";
import { HubPrivateRouter } from "@hub/routes/Router";
import { ProfilePrivateRouter } from "@profile/routes/Router";
import PrivateRoutes from "@shared/routes/PrivateRoutes";
import PublicRoutes from "@shared/routes/PublicRoutes";
import {
	pagePaths,
	privatePagePaths,
	publicPagePaths,
} from "@shared/routes/pageNames";
import { setPageTitle } from "@shared/services/pageTitle";
import PageLoader from "@shared/ui/PageLoader";
import { TallyPrivateRouter } from "@tally/routes/Router";

export function Router() {
	const [alreadyRanFirstPageload, setAlreadyRanFirstPageload] = useState(false);
	const location = useLocation();
	const { track } = useRedline();
	const { runDatadogStartView } = useDatadog({
		pagePaths,
		privatePagePaths,
		publicPagePaths,
	});
	const checkoutSessionConfig = useCheckoutSessionConfig();

	useEffect(() => {
		setPageTitle(location.pathname);
	}, [location]);

	useEffect(() => {
		if (!alreadyRanFirstPageload) {
			setAlreadyRanFirstPageload(true);
			return;
		}

		// Delay lets the new page's title/metadata settle before tracking
		const t = setTimeout(() => {
			track.auto.pageViewed();
		}, 800);

		return () => clearTimeout(t);
	}, [location]);

	useEffect(() => {
		runDatadogStartView();
	}, [runDatadogStartView]);

	return (
		<Suspense fallback={<PageLoader />}>
			<Routes>
				<Route element={<PublicRoutes />}>{AdmissionPublicRouter()}</Route>

				<Route element={<PrivateRoutes />}>
					<Fragment key="admission">{AdmissionPrivateRouter()}</Fragment>
					<Fragment key="profile">{ProfilePrivateRouter()}</Fragment>
					<Fragment key="dues">
						{DuesPrivateRouter({ checkoutSessionConfig })}
					</Fragment>
					<Fragment key="tally">{TallyPrivateRouter()}</Fragment>
					<Fragment key="hub">{HubPrivateRouter()}</Fragment>
					<Fragment key="bureau">{BureauPrivateRouter()}</Fragment>
				</Route>
			</Routes>
		</Suspense>
	);
}
